import { P } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { EditDataSetModalComponent } from '../edit-data-set-modal/edit-data-set-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/shared/services/user.service';
import { User } from 'src/app/shared/models/user.model';
import { UserProDataSet } from 'src/app/shared/models/user-pro-data-set';
import { UserProDataSetProperty } from 'src/app/shared/models/user-pro-data-set-property';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-pro-data-filter-modal',
  templateUrl: './pro-data-filter-modal.component.html',
  styleUrls: ['./pro-data-filter-modal.component.scss']
})
export class ProDataFilterModalComponent implements OnInit {

  //test data - this should be obtainable from the existing data, just have to find it

  //data sets for each pro type for the current user
  userDataSets: UserProDataSet[] = [];

  //the dataset which matches the selected pro type
  selectedDataSet: UserProDataSet;

  userTypes: any[] = []

  partnerProProperties: string[];

  selectableProperties: any[] = [];

  selectedProType: string;

  //selectedUserType: string;

  //allUserAccounts: any[] = [];
  selectedUser: any;

  //excludes Super Admin since we won't be editing data sets for those users
  nonSuperAdminUsers: any[] = [];

  //excludes any users who don't have an existing dataset
  usersWithDataSets: any[] = [];


  staffUsers: any[] = [];

  constructor(private partnerService: PartnerService, private importService: ImportService, public dialog: MatDialog, private userService: UserService, private snackbarService: SnackBarService) { }

  ngOnInit() {

    //track the selected pro type
    this.partnerService.proType$.subscribe((x) => {
      this.selectedProType = x;

      //get data set for current user
      this.partnerService.getUserDataSets(this.userService.currentUser.id).subscribe(resDataSets => {
        this.userDataSets = resDataSets;

        this.selectedDataSet = this.userDataSets.find(set => set.proType == this.selectedProType);

        //clear values for resetting
        this.selectableProperties = [];


        if (this.selectedDataSet) {

          this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);

          //we have an existing data set for this user and pro type

          // this.selectedDataSet.properties.forEach(prop => {

          //   let selectableProp = {
          //     isSelected: prop.isSelected,
          //     name: prop.propertyName
          //   };

          //   this.selectableProperties.push(selectableProp);
          // })
        }
        else {
          //create a new selectedDataSet which will be saved if applied

          this.selectedDataSet = new UserProDataSet();
          this.selectedDataSet.userId = this.userService.currentUser.id;
          this.selectedDataSet.proType = this.selectedProType;

          this.importService.approvedCatLabels$.subscribe((x) => {
            this.partnerProProperties = x;

            //reset
            this.selectedDataSet.properties = [];

            this.partnerProProperties.forEach(prop => {

              var property = new UserProDataSetProperty();
              property.propertyName = prop;
              property.isSelected = true;
              property.isRestricted = false;

              this.selectedDataSet.properties.push(property);

              // let selectableProp = {
              //   isSelected: true,
              //   name: prop
              // };

              //this.selectableProperties.push(selectableProp);
            })

            this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);
          })

        }

        //get user accounts
        this.partnerService.getStaffAccounts().subscribe((x) => {

          //filter out super admins
          let userAccountsFiltered = x.results.filter(item => !item.groups.includes(1));

          //set global variable
          this.partnerService.setNonSuperAdminUsers(userAccountsFiltered);

        });

        //track non super admin accounts
        this.partnerService.nonSuperAdminUsers$.subscribe((resNonAdmins) => {
          this.nonSuperAdminUsers = resNonAdmins;

          // Extract the id value from each object
          const userIds = this.nonSuperAdminUsers.map(user => user.id);

          //get data sets for non admin users
          this.partnerService.getDataSetsByUsers(userIds).subscribe((resDataSets) => {
            this.partnerService.setUserDataSets(resDataSets);

          });

        });

        //track data sets for non admin users
        this.partnerService.userDataSets$.subscribe((x) => {
          this.userDataSets = x;

          //reset 
          this.usersWithDataSets = [];

          this.userDataSets.forEach(set => {
            let user = this.nonSuperAdminUsers.find(user => user.id === set.userId)

            if (!this.usersWithDataSets.includes(user)) {
              this.usersWithDataSets.push(user);
            }
          });

        });

        //retrieve and set user types
        this.partnerService.getUserTypes().subscribe((x) => {
          this.partnerService.setUserTypes(x);
        });

        //track user types from global variable
        this.partnerService.userTypes$.subscribe((x) => {
          this.userTypes = x;
        });

        //retrieve properties list for partner pros
        this.importService.getApprovedCatLabels().subscribe((x) => {
          this.importService.setApprovedCategoryLabels(x);
        });


      });
    })
  }

  //selects all properties for viewing
  selectAllProperties() {
    this.selectedDataSet.properties.forEach(item => {
      item.isSelected = true;
    })
  }


  updateDataSetDisplay() {
    //the selectedUser has been changed - find their data set
  }

  /**
   * Opens modal for editing data set
   */
  editDataSet() {
    if (this.selectedUser) {
      const dialogRef = this.dialog.open(EditDataSetModalComponent, {
        // width: '800px',
        // height: '400px',
        data: { selectedUser: this.selectedUser, proType: this.selectedProType } // If you need to pass data
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');


      });
    }
  }


  /**
   * Applies the filters to the current users display
   */
  applyFilters() {
    //save selectedDataSet
    if (this.selectedDataSet.id) {
      //update
      this.partnerService.updateUserProDataSet(this.selectedDataSet).subscribe(
        (resDataSet) => {
          this.selectedDataSet = resDataSet;

          //save to global selectedDataSet
          this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);

          this.snackbarService.showSnackBarMessage("Filters Applied!", "Close")
        },
        (error) => {
          //handle error
          this.snackbarService.showSnackBarMessage("An error occurred applying these filters.", "Close", undefined, true);

        })
    }
    else {
      //post

      const formattedProperties = this.selectedDataSet.properties.map(prop => ({
        isSelected: prop.isSelected,
        name: prop.propertyName,
        isRestricted: prop.isRestricted
      }));

      this.partnerService.postDataSet(this.selectedDataSet.userId, this.selectedDataSet.proType, formattedProperties).subscribe(
        (resDataSet) => {
          this.selectedDataSet = resDataSet;

          //save to global selectedDataSet
          this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);
        },
        (error) => {
          //handle error
        })
    }

  }

  //returns false if the property isn't a column
  includeProperty(prop: string): boolean{
     return this.partnerService.masterColumns.some(col => col.name.toLowerCase() === prop.toLowerCase());
  }
}



